import { useUpdateEffect } from '@vista-digital/react-tools';
import { useContext } from 'react';
import { TicketRedemptionCodeFormActionType as ActionType } from '../../ticket-redemption-code-form/types/action-type';
import { TicketRedemptionCodeFormContextInstance } from '../../ticket-redemption-code-form/types/context';
// TODO: Add tests #289774
export const useResetField = (props, showField) => {
    const { fieldKey, setHelpText } = props;
    const { setValidationResult, dispatch, formData } = useContext(TicketRedemptionCodeFormContextInstance);
    useUpdateEffect(() => {
        if (!showField) {
            setValidationResult({ isValid: true, validationErrors: {} });
            setHelpText === null || setHelpText === void 0 ? void 0 : setHelpText(undefined);
            dispatch({ type: ActionType.SetFormData, formData: Object.assign(Object.assign({}, formData), { [fieldKey]: '' }) });
        }
    }, [showField]);
};
